import { LoadingButton } from '@mui/lab';
import { Backdrop, Card, Fade, Grid, Modal, Typography } from '@mui/material';
import React from 'react';
import WO2Button from 'src/common/components/button/Button';
import { GetReportParametersViewModel } from '../../store/types';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  handleDelete: () => void;
  row: GetReportParametersViewModel;
}

export const ReportingParametersDeleteModal = (props: Props) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.isOpen}
      onClose={() => {
        props.handleClose();
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={props.isOpen}>
        <Card
          elevation={0}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: 400,
            padding: 2,
            width: '100%',
          }}
        >
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Typography variant="h4">Are you sure you would like to delete {props.row.name}?</Typography>
            </Grid>
            <Grid item container spacing={4}>
              <Grid item flex={1}>
                <WO2Button variant="outlined" onClick={props.handleClose}>
                  Close
                </WO2Button>
              </Grid>
              <Grid item>
                <LoadingButton
                  loading={false}
                  variant="contained"
                  onClick={() => {
                    props.handleDelete();
                    props.handleClose();
                  }}
                >
                  Delete
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Fade>
    </Modal>
  );
};
